import { Typography } from "@/Components/v2/atoms/Typography";

import { AskQuestionResult } from "../api";
import { ErrorMaiteAgentChatBubble, MaiteAgentChatBubble } from "./ChatBubbles";
import { Markdown } from "./Markdown";

export const AnswerMessages = ({ messages }: { messages: AskQuestionResult["content"] }) => {
  return (
    <MaiteAgentChatBubble mb={1.5}>
      <Markdown>{messages}</Markdown>
    </MaiteAgentChatBubble>
  );
};

export const ErrorAnswerMessages = ({ messages }: { messages: string }) => {
  return (
    <ErrorMaiteAgentChatBubble mb={1.5}>
      <Typography variant="body1" fontWeight={600} color={"black"}>
        Something went wrong.
      </Typography>
      <Markdown>{messages}</Markdown>
    </ErrorMaiteAgentChatBubble>
  );
};
